import script from "./DetailsFeaturesSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsFeaturesSlide.vue?vue&type=script&setup=true&lang=js"

import "./DetailsFeaturesSlide.vue?vue&type=style&index=0&id=e2e51752&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2e51752"]])

export default __exports__